define("analytics/routes", ["exports", "ember-engines/routes"], function (_exports, _routes) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;

  var _default = (0, _routes.default)(function () {
    this.route('profile', {
      path: '/:slug'
    }, function () {
      this.route('instagram', function () {
        this.route('overview', function () {
          this.route('lifespan', {
            path: 'lifespan/:media_item'
          });
        });
        this.route('audience');
        this.route('posts', function () {
          this.route('lifespan', {
            path: 'lifespan/:media_item'
          });
        });
        this.route('reels', function () {
          this.route('lifespan', {
            path: 'lifespan/:media_item'
          });
        });
        this.route('linkinbio');
        this.route('stories', function () {
          this.route('lifespan', {
            path: 'lifespan/:media_item'
          });
        });
        this.route('hashtags', function () {
          this.route('details', {
            path: '/:hashtag'
          }, function () {
            this.route('index', {
              path: '/details'
            });
            this.route('lifespan', {
              path: 'lifespan/:media_item'
            });
          });
        });
      });
      this.route('facebook', function () {
        this.route('audience');
      });
      this.route('pinterest', function () {
        this.route('overview', function () {
          this.route('lifespan', {
            path: 'lifespan/:pin'
          });
        });
        this.route('pins', function () {
          this.route('lifespan', {
            path: 'lifespan/:pin'
          });
        });
      });
      this.route('twitter', function () {
        this.route('overview', function () {
          this.route('lifespan', {
            path: 'lifespan/:media_item'
          });
        });
        this.route('tweets', function () {
          this.route('lifespan', {
            path: 'lifespan/:media_item'
          });
        });
      });
      this.route('tiktok', function () {
        this.route('overview', function () {
          this.route('lifespan', {
            path: 'lifespan/:media_item'
          });
        });
        this.route('audience');
        this.route('posts', function () {
          this.route('lifespan', {
            path: 'lifespan/:media_item'
          });
        });
      });
    });
    this.route('restricted');
  });

  _exports.default = _default;
});